import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllEmployeeTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmployeeType}?isAll=true&isTrue=${isTrue}` //&CompanyCode=${companyCode}`
  );
  return data;
};

const getEmployeeTypeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmployeeType}?Code=${code}` // CompanyCode=${companyCode}&
  );
  return data;
};

const insertEmployeeType = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.EmployeeType, input);
  return data;
};

const updateEmployeeType = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.EmployeeType, input);
  return data;
};

const deleteEmployeeType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.EmployeeType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetEmployeeTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmployeeType],
    queryFn: () => getAllEmployeeTypes(input),
     refetchOnWindowFocus: false,
    
  });
};

export const useGetEmployeeTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmployeeType],
    queryFn: () => getEmployeeTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertEmployeeTypeMutation = () => {
  return useMutation({
    mutationFn: insertEmployeeType,
  });
};

export const useUpdateEmployeeTypeMutation = () => {
  return useMutation({
    mutationFn: updateEmployeeType,
  });
};

export const useDeleteEmployeeTypeMutation = () => {
  return useMutation({
    mutationFn: deleteEmployeeType,
  });
};
